(() => {
  angular
    .module('complianceFrameworkApp.complianceServices')
    .controller('ConsumerComplaintSearchFormController', ConsumerComplaintSearchFormController);

  /* ngInject */
  function ConsumerComplaintSearchFormController($state, $stateParams, Flash, consumerComplaintSearchService, sessionService) {
    const vm = this;

    vm.consumerComplaintSearch = {};
    vm.consumerComplaintSearchForm = {};
    vm.deleteConsumerComplaintSearch = deleteConsumerComplaintSearch;
    vm.isNew = $stateParams.id == null;
    vm.loading = false;
    vm.saveConsumerComplaintSearch = saveConsumerComplaintSearch;

    activate();

    function activate() {
      if (!vm.isNew) {
        getConsumerComplaintSearch();
      } 
    }

    function deleteConsumerComplaintSearch() {
      angular.element('#deleteConsumerComplaintSearchModal').modal('hide');

      consumerComplaintSearchService(sessionService.getAuthToken()).delete({ id: $stateParams.id }, vm.consumerComplaintSearch, _ => {
        Flash.create('success', 'Consumer complaint search successfully deleted.'); 
        $state.go('application.compliance_services.consumer_complaint_searches');
      }, _ => {
        Flash.create('danger', 'An error occurred with the submission. Please correct the following errors on the form and resubmit.');
      });     
    }

    function getConsumerComplaintSearch() {
      vm.loading = true;
      consumerComplaintSearchService(sessionService.getAuthToken()).get({id: $stateParams.id}, response => vm.consumerComplaintSearch = response);
    }

    function saveConsumerComplaintSearch() {
      if (vm.isNew) {
        consumerComplaintSearchService(sessionService.getAuthToken()).save(vm.consumerComplaintSearch, response => {
          $state.go('application.compliance_services.consumer_complaint_search_detail', { id: response.id });
          Flash.create('success', 'Consumer Complaint Search successfully created.');
        }, _error => {

        });
      } else {
        consumerComplaintSearchService(sessionService.getAuthToken()).update({ id: vm.consumerComplaintSearch.id }, vm.consumerComplaintSearch, _response => {
          $state.go('application.compliance_services.consumer_complaint_search_detail', { id: vm.consumerComplaintSearch.id });
          Flash.create('success', 'Consumer Complaint Search successfully updated.');
        }, _error => {

        });
      }
    }
  }
})();